import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "qk-frame-wrapper" }
const _hoisted_2 = { id: "frame" }

import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';

// import { Watermark as EcyWatermark } from '@mi/ecy-watermark';
// @ts-ignore - Vue 3 setup 语法组件支持默认导入
import MiSupport from '@/components/mi-support/index.vue';
import Topbar from '@/components/topbar/top.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const watermark = ref<any>('');
const route = useRoute();
onMounted(() => {
  const userInfo: { account: string; userName: string } = JSON.parse(
    localStorage.getItem('userInfo') || '{}'
  );
  watermark.value = `${userInfo?.account} ${userInfo?.userName}`;
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Topbar),
    _createElementVNode("section", _hoisted_1, [
      _withDirectives(_createVNode(_component_router_view, { class: "qk-main" }, null, 512), [
        [_vShow, _unref(route).name]
      ]),
      _withDirectives(_createElementVNode("section", _hoisted_2, null, 512), [
        [_vShow, !_unref(route).name]
      ])
    ]),
    _createVNode(MiSupport)
  ], 64))
}
}

})